/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const walletInvoiceTopUpRequestDataSchema = z.object({
	stripeInvoiceId: z.string(),
	status: z.string(),
})

export type WalletInvoiceTopUpRequestDataSchema = z.infer<typeof walletInvoiceTopUpRequestDataSchema>
